export default __webpack_public_path__ + "static/donizetti-7485e6cd712901d7967b990d09136ff5.jpg";